<div class="min-h-screen bg-gray-50 flex">
    <!-- Left Side: Image (Hidden on mobile) -->
    <div class="hidden lg:block lg:w-3/5 relative">
        <div class="absolute inset-0 bg-white rounded-br-[50px] rounded-tr-[50px] overflow-hidden z-10 shadow-xl">
            <img src="assets/images/Frame_1000004687.png" alt="Auth Background" class="w-full h-full object-cover" />
        </div>
    </div>

    <!-- Right Side: Form with Footer -->
    <div class="w-full lg:w-2/5 flex flex-col">
        <!-- Form Content -->
        <div class="flex-1 flex items-center justify-center p-8 bg-white">
            <div class="w-full max-w-md space-y-8">
                <!-- Logo & Header -->
                <div class="text-center">
                    <img src="assets/images/logometasmile.png" alt="Metasmile Logo"
                        class="h-16 mx-auto mb-6 object-contain" />
                </div>

                <!-- State 0: Input Email -->
                <div *ngIf="state === 0" class="space-y-6">
                    <div class="space-y-2">
                        <h2 class="text-xl font-bold text-slate-800 uppercase tracking-wider">
                            {{ 'kwh3n2yk' | translate }}
                        </h2>
                        <p class="text-sm text-slate-500">
                            {{ 'wvgm41fo' | translate }}
                        </p>
                    </div>

                    <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" class="mt-8 space-y-6">
                        <div class="flex flex-col gap-1.5">
                            <label class="text-[10px] font-black text-slate-500 uppercase tracking-[0.15em]">
                                {{ 'py61lw1x' | translate }} <span class="text-rose-500">*</span>
                            </label>
                            <input pInputText formControlName="email" type="email"
                                [placeholder]="'abc16f4x' | translate"
                                class="w-full !rounded-xl !border-slate-200 focus:!border-primary focus:!ring-1 focus:!ring-primary transition-all p-2.5 !text-[13px]"
                                [class.ng-invalid]="forgotForm.get('email')?.touched && forgotForm.get('email')?.invalid" />
                            <small *ngIf="forgotForm.get('email')?.touched && forgotForm.get('email')?.invalid"
                                class="text-rose-500 text-[9px] uppercase tracking-wider font-bold">
                                {{ 'email_required' | translate }}
                            </small>
                        </div>

                        <div class="pt-2">
                            <app-button [fullWidth]="true" type="submit" [loading]="isLoading"
                                [disabled]="forgotForm.invalid || isLoading" [label]="'yqwqxhu2' | translate"
                                variant="primary"></app-button>
                        </div>
                    </form>
                </div>

                <!-- State 1: Success Message -->
                <div *ngIf="state === 1" class="text-center space-y-6 py-8">
                    <div
                        class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-50 text-green-500 mb-4">
                        <i class="pi pi-check text-2xl font-bold"></i>
                    </div>
                    <div class="space-y-2">
                        <h2 class="text-xl font-bold text-slate-800 uppercase tracking-wider">
                            {{ 'kdtfs0pe' | translate }}
                        </h2>
                        <p class="text-sm text-slate-500">
                            {{ 'wvgm41fo' | translate }}
                        </p>
                    </div>

                    <div class="pt-4">
                        <app-button [fullWidth]="true" (onClick)="goBack()" [label]="'rpmodxk1' | translate"
                            variant="primary"></app-button>
                    </div>
                </div>

                <!-- Back Link (only in state 0) -->
                <div *ngIf="state === 0" class="mt-8 text-center">
                    <a routerLink="/login"
                        class="text-[8.5px] font-black text-primary hover:text-primary-hover transition-colors uppercase tracking-[0.1em] cursor-pointer inline-flex items-center gap-2">
                        <i class="pi pi-arrow-left text-[8px]"></i>
                        {{ 'xepeph19' | translate }}
                    </a>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="h-16">
            <app-auth-footer />
        </div>
    </div>
</div>